"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";

export const Accordion = AccordionPrimitive.Root;

export function AccordionItem({
  value,
  children,
  className,
  disabled,
}: {
  value: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}) {
  return (
    <AccordionPrimitive.Item
      value={value}
      className={cn("border-b last:border-none relative z-1", className)}
      disabled={disabled}
    >
      {children}
    </AccordionPrimitive.Item>
  );
}

export function AccordionTrigger({
  children,
  className,
  iconClassName,
  adminIcon = true,
}: {
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
  adminIcon?: boolean;
}) {
  return (
    <AccordionPrimitive.Header>
      <AccordionPrimitive.Trigger
        className={cn(
          "group flex w-full items-center justify-between text-left text-sm font-medium",
          className
        )}
      >
        {children}
        {adminIcon && (
          <>
            <ChevronDown
              className={cn(
                "h-5 w-5 shrink-0 transition-all duration-200 text-gray-5 group-hover:text-primary-main group-data-[state=open]:hidden mr-4",
                iconClassName
              )}
            />
            <ChevronUp
              className={cn(
                "h-5 w-5 shrink-0 transition-all duration-200 text-primary-main group-data-[state=closed]:hidden mr-4",
                iconClassName
              )}
            />
          </>
        )}
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

export function AccordionContent({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <AccordionPrimitive.Content
      className={cn(
        "overflow-hidden text-sm data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown pt-[18px]",
        className
      )}
    >
      {children}
    </AccordionPrimitive.Content>
  );
}
